import React, { useState, useEffect, useRef } from 'react';
import '../../styles/global.css';
import '../../styles/variables.css';
import { Link, useNavigate } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
    const [currentIcon, setCurrentIcon] = useState(0);
    const canvasRef = useRef(null);
    const iconColors = ['#FDADEE', '#C6FF00', '#4285F4'];
    const navigate = useNavigate();

    const icons = [
        <svg xmlns="http://www.w3.org/2000/svg" width="48px" height="48px" viewBox="0 0 64 64" fill="none">
            <path d="M32 4V60M4 32H60M12 12L52 52M12 52L52 12" stroke="black" strokeWidth="10" strokeLinecap="round" />
        </svg>,
        <svg fill="#000000" width="48px" height="48px" viewBox="0 0 256 256" id="Flat" xmlns="http://www.w3.org/2000/svg">
            <path d="M90.124,46.44238,38.22363,128,90.124,209.55762a12,12,0,1,1-20.248,12.88476l-56-88a11.99935,11.99935,0,0,1,0-12.88476l56-88A12,12,0,0,1,90.124,46.44238Zm152,75.11524-56-88a12,12,0,1,0-20.248,12.88476L217.77637,128,165.876,209.55762a12,12,0,1,0,20.248,12.88476l56-88A11.99935,11.99935,0,0,0,242.124,121.55762Z" stroke="black" strokeWidth="10" strokeLinecap="round" />
        </svg>,
        <svg fill="#000000" width="48px" height="48px" viewBox="0 0 256 256" id="Flat" xmlns="http://www.w3.org/2000/svg">
            <path d="M54.79785,119.48535A34.95033,34.95033,0,0,1,49.05078,128a34.95033,34.95033,0,0,1,5.74707,8.51465C60,147.24414,60,159.8291,60,172c0,25.93652,1.84424,32,20,32a12,12,0,0,1,0,24c-19.14453,0-32.19775-6.90234-38.79785-20.51465C36,196.75586,36,184.1709,36,172c0-25.93652-1.84424-32-20-32a12,12,0,0,1,0-24c18.15576,0,20-6.06348,20-32,0-12.1709,0-24.75586,5.20215-35.48535C47.80225,34.90234,60.85547,28,80,28a12,12,0,0,1,0,24c-18.15576,0-20,6.06348-20,32C60,96.1709,60,108.75586,54.79785,119.48535ZM240,116c-18.15576,0-20-6.06348-20-32,0-12.1709,0-24.75586-5.20215-35.48535C208.19775,34.90234,195.14453,28,176,28a12,12,0,0,0,0,24c18.15576,0,20,6.06348,20,32,0,12.1709,0,24.75586,5.20215,35.48535A34.95033,34.95033,0,0,0,206.94922,128a34.95033,34.95033,0,0,0-5.74707,8.51465C196,147.24414,196,159.8291,196,172c0,25.93652-1.84424,32-20,32a12,12,0,0,0,0,24c19.14453,0,32.19775-6.90234,38.79785-20.51465C220,196.75586,220,184.1709,220,172c0-25.93652,1.84424-32,20-32a12,12,0,0,0,0-24Z" stroke="black" strokeWidth="10" strokeLinecap="round" />
        </svg>
    ];

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        let particles = [];
        const particleCount = window.innerWidth < 768 ? 60 : 120;

        const resizeCanvas = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };
        resizeCanvas();
        window.addEventListener('resize', resizeCanvas);

        class Particle {
            constructor() {
                this.x = Math.random() * canvas.width;
                this.y = Math.random() * canvas.height;
                this.size = Math.random() * 3 + 1;
                this.density = Math.random() * 30 + 1;
                this.color = `rgba(255, 160, 0, ${Math.random() * 0.5 + 0.1})`;
                this.baseX = this.x;
                this.baseY = this.y;
                this.velocity = Math.random() * 0.2 - 0.1;
                this.angle = 0;
            }

            draw() {
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
                ctx.closePath();
                ctx.fillStyle = this.color;
                ctx.fill();
            }

            update() {
                this.angle += 0.01;
                this.x = this.baseX + Math.cos(this.angle) * 30;
                this.y = this.baseY + Math.sin(this.angle) * 30;

                const dx = mouse.x - this.x;
                const dy = mouse.y - this.y;
                const distance = Math.sqrt(dx * dx + dy * dy);
                const forceDirectionX = dx / distance;
                const forceDirectionY = dy / distance;
                const maxDistance = 100;
                let force = (maxDistance - distance) / maxDistance;

                if (distance < maxDistance) {
                    const directionX = forceDirectionX * force * this.density * 0.6;
                    const directionY = forceDirectionY * force * this.density * 0.6;
                    this.x -= directionX;
                    this.y -= directionY;
                } else {
                    if (this.x !== this.baseX) {
                        this.x -= (this.x - this.baseX) / 10;
                    }
                    if (this.y !== this.baseY) {
                        this.y -= (this.y - this.baseY) / 10;
                    }
                }

                this.draw();
            }
        }

        const mouse = {
            x: null,
            y: null
        };

        window.addEventListener('mousemove', (event) => {
            mouse.x = event.x;
            mouse.y = event.y;
        });

        const init = () => {
            particles = [];
            for (let i = 0; i < particleCount; i++) {
                particles.push(new Particle());
            }
        };

        const animate = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            for (let i = 0; i < particles.length; i++) {
                particles[i].update();
            }
            requestAnimationFrame(animate);
        };

        init();
        animate();

        const iconInterval = setInterval(() => {
            setCurrentIcon((prev) => (prev + 1) % icons.length);
        }, 1500);

        return () => {
            clearInterval(iconInterval);
            window.removeEventListener('resize', resizeCanvas);
        };
    }, []);

    return (
        <section className="hero" id="hero">
            <canvas ref={canvasRef} className="particle-canvas"></canvas>
            <div className="hero-content">
                <h1 className="hero-title">
                    <span className="hero-title-line icon-inline">
                        Your Success
                        <span
                            className="hero-icon-container"
                            style={{ backgroundColor: iconColors[currentIcon] }}
                        >
                            <span className="hero-icon">
                                {icons[currentIcon]}
                            </span>
                        </span>
                        <span>Is</span>
                    </span>
                    <span className="hero-title-line">Our Purpose</span>
                </h1>
                <p className="hero-subtitle">
                    Skript empowers your business with tailored digital solutions.<br />
                    From websites to mobile apps and desktop software,<br />
                    we build it all — fast, smart, and scalable.
                </p>
                <button className="hero-button" onClick={() => window.open('/project_prompt', '_blank', 'noopener,noreferrer')}>
                    Get Started</button>
            </div>
        </section>
    );
};

export default Hero;
